export default __webpack_public_path__ + "static/media/boite14.3aa2c298.jpg";